module.exports = __webpack_public_path__ + "img/Charging.a120284f.png";